import usePrivateAxios from "@/common/api/usePrivateAxios";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { MissionsTransformer } from "../services/missionsTransformer";
import { MissionFilters } from "../types/mission.type";

type UseMissionsListProps = {
  filters?: MissionFilters & { establishmentId?: string }
}

export const useMissionsList = ({ filters }: UseMissionsListProps) => {
  const privateAxios = usePrivateAxios()
  const {
    search,
    page,
    status,
    creatorEstablishmentCompanyBranchId,
    availableFromGteq,
    availableFromLteq,
    validity,
    establishmentId,
  } = filters || {}

  return useQuery({
    queryKey: [
      'missions',
      search ?? null,
      page ?? null,
      status ?? null,
      creatorEstablishmentCompanyBranchId ?? null,
      availableFromGteq ?? null,
      availableFromLteq ?? null,
      validity ?? null,
      establishmentId ?? null,
    ],
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const response = await privateAxios.get('/tmais/missions', {
        params: {
          search: search || undefined,
          page: page || undefined,
          'q[status_eq]': status || undefined,
          'q[establishment_company_branch_id_eq]':
            creatorEstablishmentCompanyBranchId !== 'null' ? creatorEstablishmentCompanyBranchId : undefined,
          'q[creator_establishment_company_branch_id_null]':
            creatorEstablishmentCompanyBranchId === 'null' ? true : undefined,
          'q[available_from_gteq]': availableFromGteq || undefined,
          'q[available_from_lteq]': availableFromLteq || undefined,
          validity: validity || undefined,
          establishment_id: establishmentId || undefined,
        },
      })
      const payload = response.data?.data || response.data || []
      const included = response.data?.included
      const meta = response.data?.meta || response.data?.pagination || {}
      const missions = MissionsTransformer.listFromApi(payload, included)
      return {
        data: missions,
        rows: MissionsTransformer.toTableRows(missions),
        meta,
      }
    },
  })
}

